import { Box, Stack, Typography } from "@mui/material"
import { DateDisplay } from "."
import dayjs from "dayjs"
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { MeetingLinks } from "./CalendlyScheduler";
import { useAdvisor } from "../../advisor/context/AdvisorContext";
import { useDealContext } from "../../deal/context";
import { SchedulerType } from "../../../types";

dayjs.extend(utc);
dayjs.extend(timezone);

export const MeetingDisplay = ({ meeting, advisor, size = "normal" }: { meeting: any, advisor: any, size?: "normal" | "small" }) => {
    const { fetchAdvisor } = useAdvisor();
    const { dealContext } = useDealContext();

    const handleMeetingEvent = (e: any, meetingUuid: string) => {
        fetchAdvisor(dealContext.project.tag);
    }

    return (
        <Stack direction="row" spacing={2}>
            <Box sx={{ paddingLeft: size === "small" ? "0" : "10px" }}>
                <DateDisplay meeting={meeting} />
            </Box>
            <Box sx={{}}>
                <Typography variant="body1" sx={{ fontSize: size === "small" ? '0.8rem' : '0.9rem' }}><strong>{advisor.survey_link.project.effective_scheduler_properties?.[meeting.scheduler.type as SchedulerType]?.name}</strong><br />
                    {dayjs(meeting.event_start).tz(dayjs.tz.guess()).format("h:mm A z")}
                </Typography>
                {!meeting.override_calendly &&
                    <Box sx={{ fontSize: size === "small" ? '0.8rem' : '0.9rem' }}>
                        <MeetingLinks advisor={advisor} meeting={meeting} handleMeetingEvent={handleMeetingEvent} fetchMeetingDetails={() => { }} />
                    </Box>
                }
            </Box>
        </Stack>
    )
}